import actions from './actions';

const {
  GET_ALL_PROMOS_BEGIN,
  GET_ALL_PROMOS_ERR,
  GET_ALL_PROMOS_SUCCESS,

  RESET_SINGLE_PROMO_DATA,

  GET_SINGLE_PROMO_BEGIN,
  GET_SINGLE_PROMO_ERR,
  GET_SINGLE_PROMO_SUCCESS,

  EDIT_PROMO_BEGIN,
  EDIT_PROMO_ERR,
  EDIT_PROMO_SUCCESS,

  ADD_PROMO_BEGIN,
  ADD_PROMO_ERR,
  ADD_PROMO_SUCCESS,
} = actions;

const initialStateSinglePromo = {
  data: null,
  loading: false,
  error: null,
  editPromo: {
    loading: false,
    error: false,
    data: null,
  },
};

const initialStateAllPromos = {
  data: [],
  loading: false,
  error: null,
};

const promosReducer = (state = initialStateAllPromos, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_ALL_PROMOS_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_PROMOS_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };
    case GET_ALL_PROMOS_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const singlePromoReducer = (state = initialStateSinglePromo, action) => {
  const { type, data, err } = action;
  switch (type) {
    case RESET_SINGLE_PROMO_DATA:
      return initialStateSinglePromo;
    case GET_SINGLE_PROMO_BEGIN:
      return {
        ...state,
        editPromo: {
          loading: false,
          error: null,
          data: null,
        },
        loading: true,
      };
    case GET_SINGLE_PROMO_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };
    case GET_SINGLE_PROMO_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
    case ADD_PROMO_BEGIN:
      return {
        ...state,
        loading: true,
        editPromo: {
          data: null,
          loading: true,
          error: err,
        },
      };
    case ADD_PROMO_SUCCESS:
      return {
        ...state,
        editPromo: {
          data,
          loading: false,
          error: null,
        },
      };
    case ADD_PROMO_ERR:
      return {
        ...state,
        editPromo: {
          data: null,
          loading: false,
          error: err,
        },
      };
    case EDIT_PROMO_BEGIN:
      return {
        ...state,
        editPromo: {
          ...state.editPromo,
          loading: true,
        },
      };
    case EDIT_PROMO_SUCCESS:
      return {
        ...state,
        editPromo: {
          ...state.editPromo,
          data,
          loading: false,
          error: null,
        },
      };
    case EDIT_PROMO_ERR:
      return {
        ...state,
        editPromo: {
          ...state.editPromo,
          loading: false,
          error: err,
        },
      };
  }
};

export { singlePromoReducer, promosReducer };
